import { commonMutationTypes, commonPaginationTypes, OrderDirection, pageInfo } from "../../../../../../utils/commonQueryTypes";

  
  export enum AtsStckCategoryOrderField {
    CREATED_AT="CREATED_AT",
    CATEGORY_NAME="CATEGORY_NAME",
    SL_NO="SL_NO",
  }
  
  export interface GetStockCategoriesVars extends commonPaginationTypes {
    customer_id: number;
    orderBy: {
      direction: OrderDirection;
      field: AtsStckCategoryOrderField;
    };
    name: string;
  }
  
  export interface AtsStckCategory {
    id: number;
    categoryName: string;
    slNo: number;
    customerID: number;
  }
  
  export interface AtsStckCategoryEdge {
    node: AtsStckCategory;
    cursor: string;
  }
  
  interface GetStockCategoriesData {
    edges: AtsStckCategoryEdge[];
    pageInfo: pageInfo;
    totalCount: number;
  }
  
  export interface GetStockCategoriesResult {
    GetStockCategories: GetStockCategoriesData;
  }
  
  //Mutations
  
  
  
  export interface AddStockCategoryVar extends commonMutationTypes {
    category_name: string;
    customer_id: number;
  }
  
  export interface AddStockCategoryResult {
    AddStockCategory: boolean;
  }
  
  export interface UpdateStockCategoryVar extends commonMutationTypes {
    category_id: number;
    category_name: string;
  }
  
  export interface UpdateStockCategoryResult {
    UpdateStockCategory: boolean;
  }
  
  export interface DeleteCategoryByIdResult {
    DeleteStockCategory:boolean;
  }

  export interface DeleteCategoryByIdVars extends commonMutationTypes{
    category_id:number;
  }